import { AxiosRequestConfig } from 'axios';
import { api } from 'src/boot/axios';

export const request = <T>(config: AxiosRequestConfig): Promise<T> => {
  return api(config).then((response) => response.data);
};
